<template>
        <p class="date  white--text " style="padding-left:5px;padding-right:5px">{{ digitalClock.date }} {{ digitalClock.time }}</p>
</template>
<script>
export default {
    data: () => ({
        digitalClock:{
            date:null,
            time:null,
        }
    }),
    mounted:function() {
        this.digitalClock.date = ''
                
       // this.digitalClock.time = new Time()
        setInterval(this.updateTime,1000)
    },  
    methods: {
        updateTime() {
            var cd = new Date();
            this.digitalClock.time = this.zeroPadding(cd.getHours(), 2) + ':' + this.zeroPadding(cd.getMinutes(), 2) + ':' + this.zeroPadding(cd.getSeconds(), 2);
            this.digitalClock.date = this.zeroPadding(cd.getMonth()+1, 2) + '-' + this.zeroPadding(cd.getDate(), 2) + ' '+this.zeroPadding(cd.getFullYear(), 4) //+ week[cd.getDay()];
        },
        zeroPadding(num, digit) {
            var zero = '';
            for(var i = 0; i < digit; i++) {
                zero += '0';
            }
            return (zero + num).slice(-digit);
        }
    }
  }
/*
var week = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
var timerID = setInterval(updateTime, 1000);
updateTime();
function updateTime() {
    var cd = new Date();
    clock.time = zeroPadding(cd.getHours(), 2) + ':' + zeroPadding(cd.getMinutes(), 2) + ':' + zeroPadding(cd.getSeconds(), 2);
    clock.date = zeroPadding(cd.getFullYear(), 4) + '-' + zeroPadding(cd.getMonth()+1, 2) + '-' + zeroPadding(cd.getDate(), 2) + ' ' + week[cd.getDay()];
};

function zeroPadding(num, digit) {
    var zero = '';
    for(var i = 0; i < digit; i++) {
        zero += '0';
    }
    return (zero + num).slice(-digit);
}

*/
</script>
<style>
p {
    margin: 0;
    padding: 0;
}
 .time {
        letter-spacing: 0.05em;
        padding: 5px 0;
    }
    .date {
        letter-spacing: 0.1em;
     
    }
.text {
        letter-spacing: 0.1em;
        font-size: 12px;
        padding: 20px 0 0;
    }
</style>